import { ParametrosIntegracaoInicial } from "../models/parametrosIntegracaoModel"
import type { ParametrosIntegracaoModel } from "../models/parametrosIntegracaoModel"
import { ParametrosIntegracaoActionsTypes } from "./parametrosIntegracaoActions"
import type { ParametrosIntegracaoActionModel } from "./parametrosIntegracaoActions"

export function parametrosIntegracaoReducer(
    state: ParametrosIntegracaoModel,
    action: ParametrosIntegracaoActionModel
): ParametrosIntegracaoModel {
    switch (action.type) {
        case ParametrosIntegracaoActionsTypes.CARREGAR:
            return action.payload

        case ParametrosIntegracaoActionsTypes.ATUALIZAR_CAMPO:
            return {
                ...state,
                [action.payload.campo]: action.payload.valor,
            }

        case ParametrosIntegracaoActionsTypes.RESETAR:
            return ParametrosIntegracaoInicial

        default:
            return state
    }
}
